<template>
  <div>
    <b-nav pills vertical>
      <b-nav-item>
        <router-link
          to="/department/quantum-material-design-and-prediction-research"
        >
          <span>&#187;</span>量子材料设计与预测
        </router-link>
      </b-nav-item>
      <b-nav-item>
        <router-link to="/department/quantum-material-preparation-research">
          <span>&#187;</span>量子材料精准制备
        </router-link>
      </b-nav-item>
      <b-nav-item>
        <router-link
          to="/department/quantum-physical-property-detection-and-regulation-research"
        >
          <span>&#187;</span>量子物性精准探测与调控
        </router-link>
      </b-nav-item>
      <b-nav-item>
        <router-link
          to="/department/quantum-device-processing-and-testing-research"
        >
          <span>&#187;</span>量子器件加工与测试
        </router-link>
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
</style>
